import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import siteType from "./configs/siteType";

Vue.use(Vuex);

// get register initial state from localstorage
const getInitialState = (key, defaultValue) => {
  const value = localStorage.getItem(key);
  if (value === null) {
    return defaultValue;
  } else {
    return JSON.parse(value);
  }
};

const downloadLink = {
  kk: {
    // mac version
    MAC_VERSION:
      "https://dl.kkphi.net/KKPoker-Client/KKPoker_2.0.234.dmg",
    CO_MAC_VERSION: 'https://dl.kkphi.net/KKPoker-Client/KKPoker_Global_2.0.234.dmg',

    // apple version
    APPLE_VERSION:
      "https://apps.apple.com/us/app/kkpoker-holdem-omaha-ofc/id1491735508",
    CO_APPLE_VERSION:
      "https://apps.apple.com/us/app/kkpoker-global/id1658264503",
    // 巴西有独立的 APPLE 下载链接
    BR_APPLE_VERSION: "https://apps.apple.com/app/kkpoker-lite/id6746912573",
    // 挪威有独立的 APPLE 下载链接
    NOR_APPLE_VERSION: 'https://apps.apple.com/us/app/kkpoker-play/id6758754445',

    // web version
    WEB_VERSION: "https://kkpoker.net/play",
    CO_WEB_VERSION: "https://kkpoker.co/play",

    //  android version
    ANDROID_VERSION: "https://dl.kkphi.net/KKPoker-Client/KKPoker_2.0.199.apk",
    CO_ANDROID_VERSION:
      "https://dl.kkphi.net/KKPoker-Client/KKPokerGlobal_2.0.199.apk",

    // windows version
    WINDOWS_VERSION: "https://dl.kkphi.net/KKPoker-Client/KKPoker_2.0.234.exe",
    CO_WINDOWS_VERSION:
      "https://dl.kkphi.net/KKPoker-Client/KKPoker_Global_2.0.234.exe",
  },
  nuts: {
    WEB_VERSION: "https://nutspoker.cc/play/",
    MAC_VERSION: "https://dl.nutspoker.cc/NUTSPOKER/NUTSPOKER_1.0.106.dmg",
    APPLE_VERSION:
      "https://apps.apple.com/az/app/nuts-poker-mobile-fun/id6742472349",
    ANDROID_VERSION: "https://dl.nutspoker.cc/NUTSPOKER/NUTSPOKER_1.0.86.apk",
    WINDOWS_VERSION: "https://dl.nutspoker.cc/NUTSPOKER/NUTSPOKER_1.0.106.exe",
  },
  den: {
    WEB_VERSION: "",
    MAC_VERSION:
      "https://apps.apple.com/us/app/kkpoker-holdem-omaha-ofc/id1491735508",
    APPLE_VERSION:
      "https://apps.apple.com/us/app/kkpoker-holdem-omaha-ofc/id1491735508",
    ANDROID_VERSION: "",
    WINDOWS_VERSION: "",
  },
};

/**
 * 配置最终的下载链接
 * 
 * kk: 
 * 根据 /checkIpLegal 接口返回的 download_application 字段 来决定 
 *  APP_TYPE_NONE = -1;
    APP_TYPE_KKPOKER = 0;
    APP_TYPE_KKPOKER_GLOBAL = 1;
    APP_TYPE_NUTSPOKER = 2;
    APP_TYPE_DENMARK = 3;
    其中 
      APP_TYPE_NONE = -1 对应 未知版本，需要根据当前的域名来判断
        kkpoker.net, kkpoker.world 对应 KKPoker 版本
        kkpoker.co 对应 KKPokerGlobal 版本，也就是 CO 版 
      APP_TYPE_KKPOKER = 0 对应 KKPoker 版本
      APP_TYPE_KKPOKER_GLOBAL = 1 对应 KKPokerGlobal 版本，也就是 CO 版
      APP_TYPE_NUTSPOKER = 2 对应 NutsPoker 版本，在 kk 环境中不用理会
      APP_TYPE_DENMARK = 3 对应 丹麦包 版本， 即 downloadLink.den

  ------------------------------------------------------------------

  * nut: 固定写死 读取 downloadLink.nuts 里面的值
 */
const getDownloadLink = (value) => {
  let { kk, nuts, den } = downloadLink;
  let download_application = value.download_application;
  if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
    let result = {
      web: nuts.WEB_VERSION,
      mac: nuts.MAC_VERSION,
      apple: nuts.APPLE_VERSION,
      android: nuts.ANDROID_VERSION,
      windows: nuts.WINDOWS_VERSION,
    };
    return result;
  } else {
    let result = {
      web: kk.WEB_VERSION,
      mac: kk.MAC_VERSION,
      apple: kk.APPLE_VERSION,
      android: kk.ANDROID_VERSION,
      windows: kk.WINDOWS_VERSION,
    };

    switch (download_application) {
      case -1:
        let isCuracao = window.currentType === "curacao";

        if (!isCuracao) {
          result.web = kk.WEB_VERSION;
          result.android = kk.ANDROID_VERSION;
          result.windows = kk.WINDOWS_VERSION;
        } else {
          result.web = kk.CO_WEB_VERSION;
          result.android = kk.CO_ANDROID_VERSION;
          result.windows = kk.CO_WINDOWS_VERSION;
          result.apple = kk.CO_APPLE_VERSION;
          result.mac = kk.CO_MAC_VERSION;
        }
        break;
      case 0:
        result.web = kk.WEB_VERSION;
        result.android = kk.ANDROID_VERSION;
        result.windows = kk.WINDOWS_VERSION;
        // 挪威有独立的 APPLE 下载链接
        let isNorway = value.platform === "Norway";
        if (isNorway) {
          result.apple = kk.NOR_APPLE_VERSION;
        }
        break;
      case 1:
        result.web = kk.CO_WEB_VERSION;
        result.android = kk.CO_ANDROID_VERSION;
        result.windows = kk.CO_WINDOWS_VERSION;
        result.apple = kk.CO_APPLE_VERSION;
        result.mac = kk.CO_MAC_VERSION;

        // 巴西有独立的 APPLE 下载链接
        let isBrazil = value.platform === "Brazil";
        if (isBrazil) {
          result.apple = kk.BR_APPLE_VERSION;
        }
        break;
      case 3:
        result.web = den.WEB_VERSION;
        result.android = den.ANDROID_VERSION;
        result.windows = den.WINDOWS_VERSION;
        break;
      default:
        break;
    }

    return result;
  }
};

export default new Vuex.Store({
  state: {
    showFeedback: true,
    scroll: 0,
    tab: 0,
    language: Cookies.get("language") || "en",
    fingerprint: "",
    club_info: {},
    platform: "",
    registerParams: getInitialState("registerParams", {}),
    downloadLink: {
      web: "",
      mac: "",
      apple: "",
      android: "",
      windows: "",
    },
  },
  getters: {
    language: (state) => state.language,
    downloadLinkGetters: (state) => state.downloadLink,
  },
  mutations: {
    changeFeedback(state, bool) {
      state.showFeedback = bool;
    },
    changeScroll(state, scroll) {
      state.scroll = scroll;
    },
    changeTab(state, tab) {
      state.tab = tab;
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_FINGERPRINT: (state, fingerprint) => {
      state.fingerprint = fingerprint;
    },
    SET_CLUB_INFO: (state, club_info) => {
      state.club_info = club_info;
    },
    SET_PLATFORM: (state, platform) => {
      state.platform = platform;
    },
    SET_REGISTER_PARAMS: (state, registerParams) => {
      // save to localstorage
      localStorage.setItem("registerParams", JSON.stringify(registerParams));
      state.registerParams = registerParams;
    },
    setDownloadLink(state, value) {
      // state.downloadLink = value
      Object.keys(value).forEach((key) => {
        Vue.set(state.downloadLink, key, value[key]);
      });
    },
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setDownloadLink({ commit }, value) {
      let downloadLink = getDownloadLink(value);
      commit("setDownloadLink", downloadLink);
    },
  },
});
